module.exports = __webpack_public_path__ + "img/ander4.0505432e.jpg";